import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EbwModalService } from '@ebw-monorepo/modal';
import { MtxGridColumn } from '@ng-matero/extensions/grid';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { take } from 'rxjs';
import { safeJsonStringify } from '@ebw-monorepo/microservices-helpers/utils/parser';

import { MapTableService } from '../../../services/map-table.service';

@Component({
  selector: 'ebw-monorepo-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.scss']
})
export class AttachmentDialogComponent implements OnInit {
  public dataGrid: any[] = [];
  public columnGrid: MtxGridColumn[] = [];

  constructor(
    public dialogRef: MatDialogRef<AttachmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _transalteService: TranslateService,
    private _ebwModalService: EbwModalService,
    private _mapTableService: MapTableService
  ) {}

  ngOnInit(): void {
    this.columnGrid = [
      {
        header: this._transalteService.instant('map.attachment_dialog.attachment'),
        field: 'link',
        width: '100px',
        type: 'button',
        buttons: [
          {
            type: 'icon',
            text: '',
            icon: 'download',
            tooltip: 'Scarica allegato',
            color: 'accent',
            click: (rowData) => {
              this._mapTableService
                .downloadAttachment(rowData.link)
                .pipe(take(1))
                .subscribe({
                  next: (url: any) => {
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${rowData['name']}`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                  },
                  error: (error: any) => {
                    this._ebwModalService.openErrorModal({
                      title: this._transalteService.instant('common.error'),
                      content: error.message != '' ? error.message : ''
                    });
                  }
                });
            }
          }
        ]
      },
      { header: this._transalteService.instant('map.attachment_dialog.name'), field: 'name', minWidth: 180 },
      {
        header: this._transalteService.instant('map.attachment_dialog.date'),
        field: 'data',
        minWidth: 180,
        formatter: (rowData) => {
          return moment(rowData.data).format('DD/MM/yyyy');
        }
      },

      { header: 'Dim', field: 'dim', minWidth: 180 },
      {
        header: 'Gps',
        field: 'gps',
        minWidth: 180,
        formatter: (rowData) => {
          return safeJsonStringify(rowData.gps, '');
        }
      },
      { header: 'Note', field: 'note', minWidth: 180 }
    ];

    this.dataGrid = this.data;
  }
}
